import { makeEntityScaffold } from '@classpass/saga-tools';
import { transformKeysToCamelCase } from 'helpers/core';
import URLS from 'constants/urls';

const get = httpClient => {
  return httpClient.get(URLS.integrators.list).then(res => transformKeysToCamelCase(res.data));
};

const handler = ({ httpClient }) => {
  return get(httpClient);
};

export default makeEntityScaffold('SAGA.API.FETCH_INTEGRATORS', handler);
